import { mergeBuilder } from '@dirootie-extensions/javascript';
import { SingleOrArray } from '@dirootie-extensions/typescript';
import _ from 'lodash';
import { Fn, has, ifElse, map, prop } from 'ramda';
import { arrayUtils } from './arrays/arrays.utils';

const mergePropsDefaults = <TProps>(
  systemDefaultProps: Partial<TProps>,
  singleDefaultProps: Partial<TProps> | Partial<TProps>[]
) => {
  const result = mergeBuilder<TProps>(systemDefaultProps, true)
    .merge(singleDefaultProps)
    .build();
  return result;
};

export const mergeArray = (
  source: any[],
  dest: any[],
  sourcekeys: SingleOrArray<string>,
  destkeys: SingleOrArray<string>
) => {
  const sourceAsObject = arrayUtils.toObjectWithKey(source, sourcekeys);
  const destAsObject = arrayUtils.toObjectWithKey(dest, destkeys);
  const result = mergePropsDefaults({} as any, [sourceAsObject, destAsObject]);
  const resultAsArray = _.values(result);
  return resultAsArray;
};

export type MergeUtils = {
  defaults: <TProps>(
    systemDefaultProps: Partial<TProps>,
    singleDefaultProps: Partial<TProps> | Partial<TProps>[]
  ) => Partial<TProps>;
  array: (
    source: any[],
    dest: any[],
    sourcekeys: SingleOrArray<string>,
    destkeys: SingleOrArray<string>
  ) => any[];
};

const internalMergeUtils = (): MergeUtils => {
  return {
    defaults: mergePropsDefaults,
    array: mergeArray,
  };
};
export const mergeUtils = internalMergeUtils();
